import React from "react";
import Slider from "react-slick";


// Custom Arrow Components
const NextArrow = (props) => {
  const { className, onClick } = props;
  return <div className={className} onClick={onClick} style={{ right: "10px", display:'flex', alignItems:'center', justifyContent:'center' }} />;
};

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return <div className={className} onClick={onClick} style={{ left: "10px", zIndex: 2,  display:'flex', alignItems:'center', justifyContent:'center'}} />;
};

const SliderComponent = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed:5000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div style={{ width: "100%", margin: "0 auto"}}>
      <Slider {...settings}>
        <div className="slider-container">
        <div className='slider-image-container'
        >
          {/* Dark Overlay */}
          <div
            style={{
              position: "absolute",
            }}
          />

          {/* Content */}
          <div className='slider-heading-container'>
            <h1 className="slider-heading"
            >
              The Most Successfull <br /> Security Agency
            </h1>

            <p className="slider-para"
              
            >
              At Octopuss Security Services, we take pride in being one of the most successful and dependable security agencies in the industry.
            </p>
          </div>
        </div>
        </div>
        {/* slider 2 */}
        <div className="slider-container">
        <div className='slider-image-container2'
        >
          {/* Dark Overlay */}
          <div
            style={{
              position: "absolute",
            }}
          />

          {/* Content */}
          <div className='slider-heading-container'>
            <h1 className="slider-heading"
            >
              The Most Successfull <br /> Security Agency
            </h1>

            <p className="slider-para"
              
            >
              We provide highly trained and professional security personnel who ensure safety, discipline, and complete protection of people.
            </p>
          </div>
        </div>
        </div>
        {/* slider 3 */}
        <div className="slider-container">
        <div className='slider-image-container3'
        >
          {/* Dark Overlay */}
          <div
            style={{
              position: "absolute",
            }}
          />

          {/* Content */}
          <div className='slider-heading-container'>
            <h1 className="slider-heading"
            >
              The Most Successfull <br /> Security Agency
            </h1>

            <p className="slider-para"
              
            >
              We offer integrated facility management solutions designed to keep your premises clean, safe, and well-maintained.
            </p>
          </div>
        </div>
        </div>
      </Slider>
    </div>
  );
};

export default SliderComponent;
